import React, { FC, memo } from 'react';
import { useField } from 'formik';
import DropdownWithChildren from '@minecraft.dropdown-with-children';
import FormikUncontrolledRadioGroup from '@minecraft.formik-uncontrolled-radio-group';
import { useProfileStatusOptions } from '@blocs.filter';
import { FilterData } from '../../../shared/types';

type Props = FilterData & { dataTestId?: string };

const ProfileStatus: FC<Props> = ({ name, label, dataTestId }) => {
  const profileStatusOptions = useProfileStatusOptions();
  const [, { value: selectedOption }] = useField(name);

  return (
    <DropdownWithChildren
      isChildrensContentFilled={Boolean(selectedOption?.value)}
      toggleLabel={label}
      dataTestId={dataTestId}
    >
      <FormikUncontrolledRadioGroup
        saveAsOption
        defaultValue={selectedOption}
        name={name}
        options={profileStatusOptions}
      />
    </DropdownWithChildren>
  );
};

export default memo(ProfileStatus);
